/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const createPropertyAddressParamsSchema = z.object({
      "city": z.string().optional(),
  "postalCode": z.string().optional(),
  "street": z.string().optional(),
  "number": z.string().optional(),
  "department": z.string().optional(),
  "commune": z.string().optional(),
  "neighborhood": z.string().optional(),
  "latitude": z.number().optional(),
  "longitude": z.number().optional()
      })